(() => {
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const initListicle = (root) => {
    const progress = root.querySelector('[data-progress]');
    const sticky = root.querySelector('[data-sticky]');
    const offer = root.querySelector('#nn-offer');
    const sources = root.querySelector('.nn-sources');

    let scrollFrame = null;
    const updateScrollUi = () => {
      scrollFrame = null;
      const documentHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const progressValue = Math.min(Math.max(window.scrollY / documentHeight, 0), 1);
      if (progress) progress.style.transform = `scaleX(${progressValue})`;

      if (sticky && offer && sources) {
        const offerBox = offer.getBoundingClientRect();
        const sourcesBox = sources.getBoundingClientRect();
        const offerVisible = offerBox.top < window.innerHeight * 0.88 && offerBox.bottom > 100;
        const sourcesReached = sourcesBox.top < window.innerHeight * 0.88;
        sticky.hidden = window.scrollY < 720 || offerVisible || sourcesReached;
      }
    };

    const onScroll = () => {
      if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(updateScrollUi);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateScrollUi();

    const form = root.querySelector('[data-purchase-form]');
    if (!form) return;

    const modeButtons = Array.from(form.querySelectorAll('[data-mode]'));
    const quantityButtons = Array.from(form.querySelectorAll('[data-qty]'));
    const quantityInput = form.querySelector('[data-quantity-input]');
    const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    const planNote = form.querySelector('[data-plan-note]');
    const ctaTotal = form.querySelector('[data-cta-total]');
    const submitButton = form.querySelector('[data-cart-submit]');
    const cartStatus = form.querySelector('[data-cart-status]');
    const sellingPlanName = root.dataset.sellingPlanName || 'Delivery every 30 days';
    let currentMode = 'one';
    let currentQuantity = 1;

    const moneyFor = (button, mode) => {
      if (!button) return '';
      return mode === 'sub' ? button.dataset.subTotal : button.dataset.oneTotal;
    };

    const renderPurchaseState = () => {
      modeButtons.forEach((button) => {
        const active = button.dataset.mode === currentMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (sellingPlanInput) sellingPlanInput.disabled = currentMode !== 'sub';

      quantityButtons.forEach((button) => {
        const quantity = Number(button.dataset.qty);
        const disabled = currentMode === 'sub' && quantity !== 1;
        const active = quantity === currentQuantity;
        button.disabled = disabled;
        button.tabIndex = active && !disabled ? 0 : -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
        const cardTotal = button.querySelector('[data-card-total]');
        const amount = moneyFor(button, currentMode);
        if (cardTotal && amount) cardTotal.textContent = amount;
      });

      if (quantityInput) quantityInput.value = String(currentQuantity);
      const selected = quantityButtons.find((button) => Number(button.dataset.qty) === currentQuantity);
      const selectedTotal = moneyFor(selected, currentMode);
      if (ctaTotal && selectedTotal) ctaTotal.textContent = selectedTotal;

      if (planNote) {
        planNote.textContent = currentMode === 'sub'
          ? `One tub. ${sellingPlanName}. Recurring billing and cancellation terms appear at checkout.`
          : 'Ships once. Choose 1, 3, or 6 tubs.';
      }
    };

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        currentMode = button.dataset.mode === 'sub' ? 'sub' : 'one';
        if (currentMode === 'sub') currentQuantity = 1;
        renderPurchaseState();
      });
    });

    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        currentQuantity = Number(button.dataset.qty) || 1;
        renderPurchaseState();
      });

      button.addEventListener('keydown', (event) => {
        const enabledButtons = quantityButtons.filter((candidate) => !candidate.disabled);
        const currentIndex = enabledButtons.indexOf(button);
        if (currentIndex < 0) return;

        let targetIndex = currentIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (currentIndex + 1) % enabledButtons.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (currentIndex - 1 + enabledButtons.length) % enabledButtons.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = enabledButtons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        const targetButton = enabledButtons[targetIndex];
        currentQuantity = Number(targetButton.dataset.qty) || 1;
        renderPurchaseState();
        targetButton.focus();
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!submitButton || submitButton.disabled) return;

      const originalLabel = submitButton.innerHTML;
      submitButton.disabled = true;
      submitButton.textContent = 'ADDING TO CART...';
      if (cartStatus) cartStatus.textContent = '';

      try {
        const response = await fetch(`${rootPath()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item to cart.');
        window.location.assign(`${rootPath()}cart`);
      } catch (error) {
        if (cartStatus) cartStatus.textContent = error.message || 'Could not add this item to cart. Please try again.';
        submitButton.disabled = false;
        submitButton.innerHTML = originalLabel;
      }
    });

    renderPurchaseState();
  };

  document.querySelectorAll('[data-nn-listicle]').forEach(initListicle);
})();
